export const SITE_DESCRIPTION =
  'VerifAEye helps Australian policyholders document and verify property damage for insurance claims. AI image analysis, secure storage in your own Google Drive, instant reports.';

export const SOFTWARE_APPLICATION_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: 'VerifAEye',
  applicationCategory: 'BusinessApplication',
  operatingSystem: 'Web',
  description: SITE_DESCRIPTION,
  url: 'https://verifaeye.com.au',
  offers: {
    '@type': 'Offer',
    price: '0',
    priceCurrency: 'AUD',
    description: 'Free tier with 5 AI photo analyses; paid credit packs available.',
  },
};

export const ORGANIZATION_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Symbionic',
  url: 'https://symbionic.com.au',
  brand: {
    '@type': 'Brand',
    name: 'VerifAEye',
    url: 'https://verifaeye.com.au',
  },
};
